import { IBlockContent } from '../interfaces';

export const getBlockItemsById = (id: string, content: IBlockContent[]) =>
  content.find((contentBlock) => contentBlock.fieldId === id)?.blockItems || [];
